import useCheckPC from "@repo/hooks/utils/useCheckPC";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import PageTitle from "@components/atoms/PageTitle";

import TabSelector from "@atoms/TabSelector";

import AccountInformation from "@pages/Account/AccountInformation";
import DrawHistory from "@pages/Account/DrawHistory";
import OrderHistory from "@pages/Account/OrderHistory";
import SessionHistory from "@pages/Account/SessionHistory";
import ShippingAddress from "@pages/Account/ShippingAddress";

import useLayout from "@hooks/reducerHooks/useLayout";
import useUser from "@hooks/reducerHooks/useUser";

import { URLS } from "@const/urls";

import { NOTIFICATIONS } from "@utils/notifications";

const ACCOUNT_TABS = [
  {
    key: "order_history",
    title: "Order\nHistory",
    path: URLS.ACCOUNT_ORDER_HISTORY,
    content: <OrderHistory />,
  },
  {
    // name: '내 정보',
    key: "personal_information",
    title: "Personal\nInformation",
    path: URLS.ACCOUNT_PERSONAL_INFORMATION,
    content: <AccountInformation />,
  },
  {
    key: "log_out",
    title: "Logout",
  },
];

function Account() {
  const location = useLocation();
  const navigate = useNavigate();

  const { openToast } = useLayout();
  const { accessToken, fetchUser, userLogout } = useUser();

  const { isPC } = useCheckPC();
  const { t } = useTranslation();

  const [currentAccountTab, setCurrentAccountTab] = useState(location.pathname);

  useEffect(() => {
    if (!accessToken) {
      navigate(URLS.LOGIN, { replace: true, state: { redirectUrl: location.pathname || URLS.HOME } });
    }
  }, []);

  useEffect(() => {
    if (location.pathname === URLS.ACCOUNT || location.pathname === `${URLS.ACCOUNT}/`) {
      navigate(URLS.ACCOUNT_ORDER_HISTORY, { replace: true });
    }

    void fetchUser({ variables: { customerAccessToken: accessToken } });
  }, []);

  useEffect(() => {
    setCurrentAccountTab(location.pathname);
  }, [location]);

  const renderTitle = () => {
    if (currentAccountTab.includes("/account/order/")) {
      return "Order\nDetail";
    } else if (currentAccountTab.includes("/account/draw/")) {
      return "Draw\nDetail";
    }

    return ACCOUNT_TABS.find((tab) => tab.path === currentAccountTab)?.title;
  };

  const handleLogout = () => {
    userLogout();
    sessionStorage.removeItem("discount_code");
    openToast(NOTIFICATIONS.SUCCESS_LOGOUT);
    navigate(URLS.HOME);
  };

  return (
    <>
      <PageTitle>{renderTitle()}</PageTitle>
      <ul className="scrollbar-hide pc:col-span-2 pc:-mt-0 pc:mb-0 pc:flex-col pc:gap-2.5 col-span-6 -mt-5 flex overflow-x-scroll overflow-y-clip">
        {ACCOUNT_TABS.map((accountTab) => (
          <TabSelector
            isAccount
            isHorizontal={!isPC}
            isSelected={
              accountTab.path === currentAccountTab ||
              (currentAccountTab.includes("/account/order/") && accountTab.path === URLS.ACCOUNT_ORDER_HISTORY) ||
              (currentAccountTab.includes("/account/draw/") && accountTab.path === URLS.ACCOUNT_DRAW_HISTORY)
            }
            key={accountTab.key}
            name={t(`account.${accountTab.key}`)}
            onClick={() => {
              accountTab.key === "log_out" ? handleLogout() : accountTab.path && navigate(accountTab.path);
            }}
          />
        ))}
      </ul>
      <Outlet />
    </>
  );
}

export default Account;
